import Product from "./product/Product";
import {
  Grid,
  Container,
  CircularProgress,
  Typography,
} from "@material-ui/core";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import useStyles from "./styles";
import { getProducts } from "../../actions/products";
import { AMAZON_USA } from "../../constants/amazonStores";

function Products({ category, pageTitle }) {
  const classes = useStyles();
  const productList = useSelector((state) => state.products);
  const dispatch = useDispatch();

  useEffect(() => {
    document.title = pageTitle;
    dispatch(
      getProducts(
        category
          ? { amazon_store: AMAZON_USA, category: category }
          : { amazon_store: AMAZON_USA }
      )
    );
  }, [category, pageTitle, dispatch]);

  const renderList = () => {
    if (productList.length !== 0) {
      return (
        <Grid className={classes.productsContainer} container spacing={3}>
          {productList.map((product) => (
            <Product key={product._id} product={product} />
          ))}
        </Grid>
      );
    }

    return (
      <div className={classes.mainContainer}>
        <Typography variant="h5" className={classes.noProductsText}>
          No products to show
        </Typography>
      </div>
    );
  };

  return (
    <Container maxWidth={false}>
      <div className={classes.pageHeader}>
        <Typography variant="h3" className={classes.pageHeaderTitle}>
          {pageTitle}
        </Typography>
      </div>
      {!productList ? (
        <div className={classes.mainContainer}>
          <CircularProgress className={classes.loader} />
        </div>
      ) : (
        renderList()
      )}
    </Container>
  );
}

export default Products;
